<template>
  <section class="dd-message">
    <div class="dd-wall-card dd-message__card">
      <h2 class="dd-message__title">{{ $t('success.thank_you_for_your_donation') }}</h2>
      <p v-if="!donationOnlyMode" class="dd-message__text">{{ $t('success.your_effect_will_appear_on_the_stream_within_a_minute') }}</p>
      <div class="dd-message__actions">
        <router-link class="dd-post__btn" to="/wall/effects">{{ $t('success.go_back') }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'WallSuccess',
  computed: {
    donationOnlyMode() {
      return this.$store.getters.donationOnlyMode;
    },
  },
  methods: {
    ...mapMutations(['setPaymentMode']),
  },
  mounted() {
    this.setPaymentMode('donation');
  },
};
</script>
